'use client';

import { useMemo } from 'react';
import { createAvatar } from '@dicebear/core';
import { glass } from '@dicebear/collection';

interface LeadListAvatarProps {
  seed: string;
  size?: number;
  className?: string;
}

export function LeadListAvatar({ seed, size = 36, className = '' }: LeadListAvatarProps) {
  const svg = useMemo(() => {
    const avatar = createAvatar(glass, {
      seed,
      size,
    });
    return avatar.toDataUri();
  }, [seed, size]);

  return (
    <img
      src={svg}
      alt=""
      width={size}
      height={size}
      className={`rounded-lg shrink-0 ${className}`}
    />
  );
}
